import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'th[appSortHeader]',
  standalone: true,
  templateUrl: './sort-header.component.html',
  styleUrl: './sort-header.component.scss',
  host: {
    class: 'sortable',
    '[class.sorted]': 'active === appSortHeader',
    '[class.desc]': 'active === appSortHeader && direction === "desc"',
    '(click)': 'sort.emit(appSortHeader)'
  }
})
export class SortHeaderComponent {
  @Input({ required: true }) appSortHeader!: string;

  @Input() active: string | null = null;

  @Input() direction: string | null = null;

  @Output() sort = new EventEmitter<string>();
}
